import React, { useEffect, useRef } from 'react';

const FirefliesBg = ({ accentColor = '#c2ffe0', isDark = true, pageBg }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let raf;

    const resize = () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; };
    window.addEventListener('resize', resize);
    resize();

    const hex2rgb = (hex) => {
      const r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return r ? [parseInt(r[1], 16), parseInt(r[2], 16), parseInt(r[3], 16)] : [194, 255, 224];
    };
    const [ar, ag, ab] = hex2rgb(accentColor);

    // ✅ Use pageBg prop
    const bg = pageBg || (isDark ? '#0a0f0a' : '#f0f8f0');

    const COUNT = 55;
    const flies = Array.from({ length: COUNT }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      vx: (Math.random() - 0.5) * 0.6,
      vy: (Math.random() - 0.5) * 0.6,
      phase: Math.random() * Math.PI * 2,
      speed: 0.01 + Math.random() * 0.02,
      size: 1.5 + Math.random() * 2.5,
      trail: [],
    }));

    let t = 0;
    const draw = () => {
      t += 0.016;
      ctx.fillStyle = bg;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      flies.forEach((f) => {
        f.phase += f.speed;
        f.x += f.vx + Math.sin(f.phase * 1.3) * 0.4;
        f.y += f.vy + Math.cos(f.phase) * 0.4;
        if (f.x < 0) f.x = canvas.width;
        if (f.x > canvas.width) f.x = 0;
        if (f.y < 0) f.y = canvas.height;
        if (f.y > canvas.height) f.y = 0;

        f.trail.push({ x: f.x, y: f.y });
        if (f.trail.length > 18) f.trail.shift();

        f.trail.forEach((pt, i) => {
          const a = (i / f.trail.length) * 0.15 * (isDark ? 1 : 0.6);
          ctx.beginPath();
          ctx.arc(pt.x, pt.y, f.size * 0.5, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(${ar},${ag},${ab},${a})`;
          ctx.fill();
        });

        const pulse = 0.5 + 0.5 * Math.sin(f.phase * 3);
        const glow = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, f.size * 5);
        glow.addColorStop(0, `rgba(${ar},${ag},${ab},${isDark ? 0.9 : 0.7})`);
        glow.addColorStop(0.4, `rgba(${ar},${ag},${ab},${pulse * (isDark ? 0.3 : 0.2)})`);
        glow.addColorStop(1, `rgba(${ar},${ag},${ab},0)`);
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.size * 5, 0, Math.PI * 2);
        ctx.fillStyle = glow;
        ctx.fill();

        ctx.beginPath();
        ctx.arc(f.x, f.y, f.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${isDark ? 0.95 : 0.8})`;
        ctx.fill();
      });

      raf = requestAnimationFrame(draw);
    };

    draw();
    return () => { window.removeEventListener('resize', resize); cancelAnimationFrame(raf); };
  }, [accentColor, isDark, pageBg]);

  return <canvas ref={canvasRef} className="fixed inset-0 z-0 pointer-events-none" />;
};

export default FirefliesBg;